import {
  REQUEST_SIGNUP_OTP,
  REQUEST_SIGNUP_OTP_SUCCESS,
  REQUEST_SIGNUP_OTP_FAILED,
  VERIFY_SIGNUP_OTP,
  VERIFY_SIGNUP_OTP_SUCCESS,
  VERIFY_SIGNUP_OTP_FAILED,
  CLEAR_SIGNUP_OTP_STATE,
} from "../store/types";

const INITIAL_STATE = {
  loading: false,
  otpSent: false,
  otpVerified: false,
  deliveryMethod: null,
  error: {
    flag: false,
    msg: null,
  },
  userData: null,
  message: null,
};

export const signupotpreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REQUEST_SIGNUP_OTP:
      return {
        ...state,
        loading: true,
        error: {
          flag: false,
          msg: null,
        },
      };
    case REQUEST_SIGNUP_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        otpSent: true,
        deliveryMethod: action.payload.deliveryMethod,
        message: action.payload.message,
        error: {
          flag: false,
          msg: null,
        },
      };
    case REQUEST_SIGNUP_OTP_FAILED:
      return {
        ...state,
        loading: false,
        otpSent: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    case VERIFY_SIGNUP_OTP:
      return {
        ...state,
        loading: true,
        error: {
          flag: false,
          msg: null,
        },
      };
    case VERIFY_SIGNUP_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        otpVerified: true,
        userData: action.payload.user,
        message: action.payload.message,
        error: {
          flag: false,
          msg: null,
        },
      };
    case VERIFY_SIGNUP_OTP_FAILED:
      return {
        ...state,
        loading: false,
        otpVerified: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    case CLEAR_SIGNUP_OTP_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
